// Footer.js
import React from 'react';

const Banner = () => {
  return (
    <div className="survey-link container">
          <div>
            <h2>Provide feedback</h2>
            <a className='' href='https://ec.europa.eu/eusurvey/runner/5de7c4d6-7992-2b8f-88cf-4afe216655ff' target='_blank'>Provide feedback for the website</a>
        </div>
    </div>
  );
};

export default Banner;
